import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Avatar, Box, Card, Grid, makeStyles } from '@material-ui/core';
import InfoPopover from '../InfoPopover';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    popover: {
      alignSelf: 'flex-start',
    },
    content: {
      padding: theme.spacing(2.5, 2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    avatar: {
      marginRight: theme.spacing(2), // 16px
      backgroundColor: theme.palette.shelfBlue['50L'],
      color: theme.palette.primary.main,
      height: 44,
      width: 44,
    },
    icon: {
      fontSize: theme.typography.pxToRem(20),
    },
    metric: {
      ...theme.typography.h3,
      display: 'flex',
    },
    metricLabel: {
      ...theme.typography.body2,
    },
  };
});

const KpiCard = ({
  className,
  metric,
  metricLabel,
  icon: iconProp,
  description,
  ...props
}) => {
  const classes = useStyles();

  let icon = null;
  if (iconProp && React.isValidElement(iconProp)) {
    icon = React.cloneElement(iconProp, {
      className: classes.icon,
    });
  }

  return (
    <Grid item lg={3} sm={6} xs={12}>
      <Card className={clsx(classes.root, className)} {...props}>
        <div className={classes.content}>
          <Avatar className={classes.avatar}>{icon}</Avatar>
          <Box flexGrow={1}>
            <span className={classes.metric}>{metric}</span>
            <span className={classes.metricLabel}>{metricLabel}</span>
          </Box>
        </div>
        <InfoPopover className={classes.popover} description={description} />
      </Card>
    </Grid>
  );
};

KpiCard.propTypes = {
  icon: PropTypes.element,
  metric: PropTypes.string,
  metricLabel: PropTypes.string,
  tooltip: PropTypes.string,
};

KpiCard.defaultProps = {};

export default KpiCard;
